<template>
  <div>
    <div class="primary--text font-weight-medium text-center">
      CHÍNH SÁCH HOA HỒNG TỪ NGÀY 01/03/2025
    </div>
    <v-simple-table fixed-header class="table-padding-2 table-h-36">
      <template v-slot:default>
        <tbody>
          <tr class="font-weight-medium black--text text-center">
            <td class="text-right" style="width: 90px; min-width: 90px">
              Ngày thuê:
            </td>
            <td>1→3 ngày</td>
            <td>4→7 ngày</td>
            <td>7→29 ngày</td>
            <td>30→365 ngày</td>
          </tr>
          <tr class="font-weight-medium black--text text-center">
            <td class="text-right">Giá ngày:</td>
            <td>150.000 đ</td>
            <td>130.000 đ</td>
            <td>100.000 đ</td>
            <td>60.000 đ</td>
          </tr>

          <template v-if="checkPermission(['rent_agency'])">
            <tr class="text-center">
              <td class="text-right">Hoa hồng/ngày</td>
              <td>50.000 đ</td>
              <td>30.000 đ</td>
              <td>15.000 đ</td>
              <td>6.000 đ</td>
            </tr>
            <tr class="text-center">
              <td class="text-right">Hoa hồng tối đa</td>
              <td>150.000 đ</td>
              <td>150.000 đ</td>
              <td>150.000 đ</td>
              <td>180.000 đ</td>
            </tr>
          </template>

          <template v-if="checkPermission(['rent_collaborator_offline'])">
            <tr class="text-center">
              <td class="text-right">Hoa hồng/ngày</td>
              <td>40.000 đ</td>
              <td>24.000 đ</td>
              <td>12.000 đ</td>
              <td>5.000 đ</td>
            </tr>
            <tr class="text-center">
              <td class="text-right">Hoa hồng tối đa</td>
              <td>120.000 đ</td>
              <td>120.000 đ</td>
              <td>120.000 đ</td>
              <td>150.000 đ</td>
            </tr>
          </template>

          <template v-if="checkPermission(['rent_collaborator'])">
            <tr class="text-center">
              <td class="text-right">Hoa hồng/ngày</td>
              <td>15.000 đ</td>
              <td>13.000 đ</td>
              <td>10.000 đ</td>
              <td>4.000 đ</td>
            </tr>
            <tr class="text-center">
              <td class="text-right">Hoa hồng tối đa</td>
              <td>45.000 đ</td>
              <td>65.000 đ</td>
              <td>110.000 đ</td>
              <td>120.000 đ</td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>

    <ul class="fs-12 mt-5 error--text font-italic">
      <li>Bảng giá bao gồm VAT.</li>
      <li>
        Hoa hồng áp dụng với hợp đồng thuê mới, không áp dụng với hợp đồng gia
        hạn
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CommissionPolicy",
  data: () => ({}),
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style scoped></style>
